import * as actions from './rfr-ord-search.actions';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import { SpxToasterAutoCloseSpeedEnum, spxToasterActions } from '@softpak/components/spx-toaster';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';

import { ApiRfrMethod } from 'src/app/api/api-methods.rfr';
import { Observable } from 'rxjs';
import { RfrOrdSearchI } from 'src/app/api/rfr-ord-search/rfr-ord-search.result.int';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { SpxCapitalizePipe } from '@softpak/components/spx-capitalize';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import rfrOrdSearchReducer from './rfr-ord-search.reducer';
import { textNewOrderAvailable } from 'src/app/shared/_config/i18n/i18n-interface';

@Injectable()
export class RfrOrdSearchEffects {
  private readonly appStore = inject(Store);
  private readonly actions$ = inject(Actions);
  private readonly sharedGenericService = inject(SharedGenericService);
  private readonly translateService = inject(TranslateService);

  load$ = createEffect(() =>
    this.actions$.pipe(ofType(actions.load),
      withLatestFrom(this.appStore.select(rfrOrdSearchReducer.selectData)),
      mergeMap(([_params, rfrOrdItems]) => this.sharedGenericService.invoke(ApiRfrMethod.rfrOrdSearch, rfrOrdItems).pipe(
        map((data: RfrOrdSearchI) => actions.received({ data: data.result })),
        catchError((error: SharedErrorObjectI) => [actions.error({ messageText: error.message })])
      ))
    ));

  afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.error),
    mergeMap((action) => [
      spxToasterActions.createError({
        autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
        messageText: action.messageText,
      }),
    ]))
  );

  afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
    ofType(actions.received),
    withLatestFrom(this.appStore.select(rfrOrdSearchReducer.selectNewOrderDetected)),
    mergeMap(([_action, newOrderDetected]) => {
      if (newOrderDetected) {
        return [
          spxToasterActions.createInfo({
            autoClose: 3000,
            messageText: SpxCapitalizePipe.transform(this.translateService.instant(textNewOrderAvailable)),
          })
        ];
      }
      return [];
    }))
  );
}
